module.exports = __webpack_public_path__ + "img/solution34.112bd5a8.png";